// signalr base
import Vue from 'vue';

const signalR = require('@microsoft/signalr');
const signalRMsgPack = require("@microsoft/signalr-protocol-msgpack");

let baseURL = '';
if (process.env.NODE_ENV !== 'development') {
  baseURL = 'wss://' + window.location.hostname + '/socketApi/betlineshub';
  baseURL = baseURL.replace(/^https?\:\/\//i, 'ws://');
} else {
  baseURL = 'wss://' + window.location.hostname + '/socketApi/betlineshub';
  baseURL = process.env.VUE_APP_SOCKET_URL;
}

if (window.location.href.includes('instabetcom-engine')) {
  baseURL = 'wss://instabetcom-engine.dev.notavailable.mx/socketApi/betlineshub';
}
if (window.location.href.includes('https://engine-stg.instabet.mx')) {
  baseURL = 'wss://engine-stg.instabet.mx/socketApi/betlineshub';
}
if (window.location.href.includes('https://kiosk-stg.instabet.mx')) {
  baseURL = 'wss://engine-fv3.instabet.com/socketApi/betlineshub';
}

if (window.location.href.includes('https://engine-preprod.instabet.mx')) {
  baseURL = 'wss://engine-preprod.instabet.mx/socketApi/betlineshub';
}

const connectionStates = {
  connecting: 0,
  connected: 1,
  reconnecting: 2,
  disconnected: 4,
};

let connection;
const init = () => {
  if (connection) return;
  connection = new signalR.HubConnectionBuilder()
    .withUrl(baseURL, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets || signalR.HttpTransportType.LongPolling,
      keepAliveIntervalInMilliseconds: 1000,
      serverTimeoutInMilliseconds: 60000
    })
    .withHubProtocol(new signalRMsgPack.MessagePackHubProtocol())
    .configureLogging(signalR.LogLevel.Information)
    .build();
};
const connect = onError => {
  return new Promise((resolve, reject) => {
    if (!connection) {
      init();
    }
    connection
      .start()
      .then(() => {
        resolve({
          state: connectionStates.connected,
        });

        connection.onclose(e => {
          onError();
        });

        connection.onerror(e => {
          onError();
        });
      })
      .catch(rej => {
        reject(rej);
      });
  });
};

const disconnect = () => {
  return new Promise((resolve, reject) => {
    init();
    connection
      .stop()
      .then(res => {
        resolve({
          state: connectionStates.disconnected,
        });
      })
      .catch(rej => {
        reject(rej);
      });
  });
};

const subscribe = (method, callBack) => {
  connection.on(method, function(args) {
    callBack(args);
  });
};

const invoke = (method, args) => {
  connection.invoke(method, args);
};

const _signalR = {
  connect,
  subscribe,
  invoke,
  disconnect,
  connection: connection,
};

Vue.prototype.$signlaR = _signalR;

export const socket = {
  connectionStates,
  _signalR,
};
